import { Loader2 } from "lucide-react";
import { cn } from "@/utils/css";

export const BatchBadgeIcon = ({ extension, isProcessing, isFailed }) => {
    if (isProcessing) {
        return <Loader2 className="size-10 text-cm-p-text-secondary animate-spin" strokeWidth={1.5} />;
    }
    const palette = isFailed
        ? "bg-cm-p-container-red text-cm-p-on-container-red"
        : "bg-cm-p-container-green text-cm-p-on-container-green";
    return (
        <div
            className={cn(
                "size-10 rounded flex items-center justify-center flex-shrink-0 uppercase text-xs font-semibold",
                palette,
            )}
        >
            {extension || "csv"}
        </div>
    );
};
